export default async function ScrollToTop() {
  const element = document.getElementById('empori-scroll-to-top-container');

  function scrollFunction() {
    if (!element){
      return;
    }
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      element.style.display = 'block';
    } else {
      element.style.display = 'none';
    }
  }

  function topFunction() {
    // Support for Safari
    document.body.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // Support for Chrome, Firefox, IE and Opera
    document.documentElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  const button = document.getElementById('empori-scroll-to-top-button');
  if(button) {
    button.addEventListener('click', topFunction);
  }
  document.addEventListener('scroll', scrollFunction);
}